import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';

export default (handler) => {
  // The `handler` is a beforeunload handler as per documentation:
  // https://github.com/remix-run/history/blob/3e9dab413f4eda8d6bce565388c5ddb7aeff9f7e/docs/blocking-transitions.md
  const enabled = typeof handler === 'function';

  // Persist handler in ref
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  });

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      enabled && handlerRef.current() && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (enabled) {
      const beforeunloadListener = (event) => {
        if (handlerRef.current()) {
          const returnValue = event.preventDefault();
          if (typeof returnValue === 'string') {
            event.preventDefault();
            // Handle legacy `event.returnValue` and `return` activation.
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#compatibility_notes
            // eslint-disable-next-line no-return-assign, no-param-reassign
            return (event.returnValue = returnValue);
          }

          // Chrome doesn't support `event.preventDefault()` on `BeforeUnloadEvent`.
          // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#compatibility_notes
          if (event.defaultPrevented) {
            // eslint-disable-next-line no-param-reassign, no-return-assign
            return (event.returnValue = '');
          }
        }

        return null;
      };

      window.addEventListener('beforeunload', beforeunloadListener);

      if (blocker && blocker.state === 'blocked') {
        // eslint-disable-next-line no-alert
        if (window.confirm('Are you sure you want to discard your changes?')) {
          setTimeout(() => blocker.proceed(), 100);
        } else {
          blocker.reset();
        }
      }

      return () => {
        window.removeEventListener('beforeunload', beforeunloadListener);
      };
    }

    return null;
  }, [enabled, blocker]);
};
